import React, { Component } from "react";
import { languages } from "../../../constants/languages";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PouleIcon from "@material-ui/icons/FormatListNumbered";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import CheckIcon from "@material-ui/icons/CheckCircle";

class StructureElementsNotDivided extends Component {
  state = {
    anchorEl: null,
  };

  openMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuItemClick = (event, structureElement) => {
    event.preventDefault();

    let numInDia = 0;
    if (this.props.structureElements.length > 0) {
      let lastElement =
        this.props.structureElements[this.props.structureElements.length - 1] ||
        {};
      numInDia =
        lastElement[
          lastElement.numInDiaLocal !== undefined ? "numInDiaLocal" : "numInDia"
        ] + 1;
    }

    let toUpdate = {};
    let diaNum = "";
    for (let x = 1; x < 100; x++) {
      if (structureElement["dia" + x.toString()] === undefined) {
        diaNum = x.toString();
        break;
      }
    }
    toUpdate["dia" + diaNum] = this.props.dia.id;
    toUpdate["numInDia" + diaNum] = numInDia;

    let collection = "poules";
    if (structureElement.isBracket) {
      collection = "brackets";
      if (
        structureElement.roundLocal !== undefined &&
        structureElement.roundPartLocal !== undefined
      ) {
        toUpdate["bracketRoundDia" + diaNum] = structureElement.roundLocal;
        toUpdate["bracketRoundPartDia" + diaNum] =
          structureElement.roundPartLocal;
      }
    }

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection(collection)
      .doc(structureElement.id)
      .update(toUpdate);
    this.closeMenu();
  };

  render() {
    return (
      <div style={{ display: "inline-block" }}>
        <Menu
          id="lock-menu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.closeMenu}
          PaperProps={{
            style: {
              maxHeight: 30 * 6,
              minWidth: 180,
            },
          }}
        >
          {this.props.structureElementsNotDivided.length === 0 && (
            <MenuItem
              style={{
                height: 75,
                padding: "0 10px",
                width: 200,
                whiteSpace: "normal",
              }}
              disabled={true}
            >
              {languages.present.allDivided}
            </MenuItem>
          )}
          {this.props.structureElementsNotDivided.map(
            (structureElement, index) => {
              let numDias = 0;
              for (let x = 0; x < 100; x++) {
                if (
                  this.props.diasByKey[
                    structureElement["dia" + (x > 0 ? x.toString() : "")]
                  ]
                ) {
                  numDias++;
                }
              }
              return (
                <MenuItem
                  style={{
                    height: 30,
                    padding: "0 40px 0 10px",
                  }}
                  key={
                    structureElement.id +
                    (structureElement.roundLocal !== undefined
                      ? structureElement.roundLocal.toString()
                      : "") +
                    (structureElement.roundPartLocal !== undefined
                      ? structureElement.roundPartLocal.toString()
                      : "")
                  }
                  onClick={(event) =>
                    this.handleMenuItemClick(event, structureElement)
                  }
                  // disabled={
                  //   structureElement.isBracket &&
                  //   (structureElement.size === 32 ||
                  //     structureElement.size === 64)
                  // }
                >
                  {structureElement.label +
                    (structureElement.roundLocal !== undefined
                      ? " - " +
                        languages.schedule.round +
                        " " +
                        structureElement.roundLocal.toString()
                      : "") +
                    (structureElement.roundPartLocal !== undefined &&
                    structureElement.numPartsLocal > 1
                      ? " (" +
                        (structureElement.roundPartLocal + 1).toString() +
                        "/" +
                        structureElement.numPartsLocal.toString() +
                        ")"
                      : "")}
                  {numDias > 0 && (
                    <ListItemSecondaryAction>
                      <IconButton
                        disabled
                        edge="end"
                        style={{ width: 30, height: 30 }}
                      >
                        <CheckIcon
                          style={{
                            height: 17,
                            position: "absolute",
                            top: 7,
                            color: "green",
                          }}
                        />
                      </IconButton>
                    </ListItemSecondaryAction>
                  )}
                </MenuItem>
              );
            }
          )}
        </Menu>
        <Tooltip title={languages.present.pouleBracket}>
          <IconButton onClick={this.openMenu} size="small">
            <PouleIcon style={{ height: 20, width: 20 }} />
          </IconButton>
        </Tooltip>
      </div>
    );
  }
}

export default StructureElementsNotDivided;
